export function getPaginationItemKind(
  currentIndex: number,
  kind: 'normal' | 'diminishing',
  visibleArray: number[],
  selectedIndex: number,
  total: number
) {
  if (kind !== 'diminishing') {
    return 'normal';
  }

  if (
    (visibleArray[0] === currentIndex && selectedIndex > 4) ||
    (visibleArray[visibleArray.length - 1] === currentIndex &&
      selectedIndex < total - 3)
  ) {
    return 'tail_dot_small';
  }
  if (
    (visibleArray[1] === currentIndex && selectedIndex > 4) ||
    (visibleArray[visibleArray.length - 2] === currentIndex &&
      selectedIndex < total - 3)
  ) {
    return 'tail_dot_large';
  }

  return 'normal';
}

export function getPaginationItemActiveIndex(
  dotCount: number,
  totalSlides: number,
  previousDotIndex: number,
  activeIndex: number,
  previousActiveIndex: number,
  kind: 'normal' | 'diminishing'
): number {
  if (kind === 'normal' || totalSlides <= 7) {
    return activeIndex;
  }

  if (dotCount === 7) {
    if (activeIndex < 3) {
      // if the activeIndex is less than 3 return it as it is
      return activeIndex;
    } else if (activeIndex > totalSlides - 3) {
      // if the activeIndex in last 3 slides, then make appropriate dot active from last 3 dots
      return 6 - (totalSlides - 1 - activeIndex);
    }
    // to handle the activeIndex movement for the slides that are in between last 3 and first 3 slides
    const diff = activeIndex - previousActiveIndex;
    if (diff > 0) {
      // to handle the movement to next slide
      if (previousDotIndex === 2) {
        return 3;
      }
      return 4;
    } else if (diff < 0) {
      // to handle the movement from last 3rd slide to previous slide
      if (previousDotIndex === 4) {
        return 3;
      }

      // to handle the movement from last 2nd slide to previous slide
      if (previousDotIndex === 5) {
        return 4;
      }
      return 2;
    }
    return 3;
  }

  return activeIndex;
}

export const getVisibleItems = (selectedIndex: number, total: number) => {
  let leftCount, rightCount;

  if (selectedIndex === total - 1) {
    leftCount = 6;
    rightCount = 0;
  } else if (selectedIndex === total - 2) {
    leftCount = 5;
    rightCount = 2;
  } else {
    leftCount = Math.min(selectedIndex, 4);
    leftCount = leftCount < 0 ? 0 : leftCount;
    rightCount = 7 - leftCount;
    rightCount = rightCount > total ? total : rightCount;
  }

  let left = Array.from({ length: leftCount + 1 }).map(
    (_, i) => selectedIndex - i
  );

  left.reverse();

  const right = Array.from({ length: rightCount }).map(
    (_, i) => selectedIndex + i
  );

  return Array.from(new Set([...left, selectedIndex, ...right]));
};
